

import React, { useEffect, useRef, useState } from 'react';
import WizardServices from './WizardServices';
import DeleteDialogueBox from '../Common/deleteDialogue';

export function ContractWizardRoyalties(MainWizard: any) {

    const [searchFor, setsearchFor] = useState("");
    const [save, setSaveAlert] = useState(false);
    let [editRate, seteditRate] = useState<any>([]);
    var [deleteJob, setdeleteJob] = useState<any>([]);
    const formValidation = useRef<HTMLDivElement>(null);
    const [deleteAlert, setDeleteAlert] = useState(false);
    let [systemRegions, setsystemRegions] = useState<any>([]);
    let [analysisCodes, setanalysisCodess] = useState<any>([]);
    let [contractRoyaltiesListing, setcontractRoyaltiesListing] = useState<any>([]);
    let [contractRoyaltyListingTemp, setcontractRoyaltyListingTemp] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {

            WizardServices.contractssystemsystemRegions(MainWizard.data.code.contractRefNum).then((value: any) => {
                setsystemRegions(value)
            })

            WizardServices.contractsanalysisCodes().then((value: any) => {
                setanalysisCodess(value)
            })

            contractRoyaltyListing();

        }
    }, []);

    const contractRoyaltyListing = () => {
        WizardServices.contractRoyaltiesListing(MainWizard.data.code.contractRefNum).then((value: any) => {
            setcontractRoyaltiesListing(value)
            setcontractRoyaltyListingTemp(value)
        })
    };

    const contractRoyaltyListingSearch = (e: any) => {

        console.log(e)
        if (e.length > 0) {
            var listSearch = contractRoyaltyListingTemp.filter((value: any) =>
                value.analysisText.toLowerCase().includes(e.toLowerCase()) ||
                value.groupDesc.toLowerCase().includes(e.toLowerCase())
            );
            setcontractRoyaltiesListing(listSearch)
        } else {
            setcontractRoyaltiesListing(contractRoyaltyListingTemp)
        }

    };

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editRate };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        editRate = updatedObject;
        seteditRate(editRate);


    };

    const handleSpecificField = (fieldName: any, value: any, object: any) => {
        console.log(fieldName)
        console.log(object)
        console.log(value)

        let updatedObject = { ...editRate }
        if (fieldName === 'groupDesc,territoryCode') {
            var found = object.filter((event: any) => (event.groupDesc === (value)));
            updatedObject.groupDesc = found[0].groupDesc
            updatedObject.territoryCode = found[0].groupingId
        }

        if (fieldName === 'UsePriceDesc,usePrice') {
            var found = object.filter((event: any) => (event.value === (value)));
            updatedObject.UsePriceDesc = found[0] && found[0].value ? found[0].value : ''
            updatedObject.usePrice = found[0] && found[0].key ? found[0].key : ''
        }


        if (fieldName === 'formatDesc,format') {
            var found = object.filter((event: any) => (event.formatDesc === (value)));
            updatedObject.formatDesc = found[0].formatDesc
            updatedObject.format = found[0].codingStr
        }

        editRate = updatedObject;
        seteditRate(editRate);
    };

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    };

    const onReducingRoyaltyDelete = (e: any) => {
        setdeleteJob(e)
        console.log(e)
    };

    const onReducingRoyaltySave = () => {
        console.log(editRate)

        var valid = handleFieldRequired(editRate)
        editRate.contractRefNum = MainWizard.data.code.contractRefNum;

        if (valid) {
            WizardServices.contractRoyaltiesSave(MainWizard.data.code.contractRefNum, editRate).then(() => {
                setSaveAlert(true);
                contractRoyaltyListing();
            })

            setTimeout(function () {
                setSaveAlert(false);
            }, 3000);

        }

    };

    const clearSForm = () => {
        editRate = []
        seteditRate(editRate)
        const inputs: any = formValidation.current?.querySelectorAll('input');
        if (inputs) {
            Object.values(inputs).map((values: any) => {
                var fieldName: any = document.getElementById(values.id);
                if (fieldName) {
                    fieldName.style.border = "1px solid #47529d";
                }


            })
        }

    };

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            WizardServices.contractRoyaltiesDelete(MainWizard.data.code.contractRefNum, e.allowId).then(() => {
                setDeleteAlert(true);
                contractRoyaltyListing();
            })
            setTimeout(function () {
                setDeleteAlert(false);
            }, 3000);
        }

        setdeleteJob({});
    };

    return (
        <>
            <div className='ws-12 ps'>
                <div className='box'>
                    <div className="box-header ws-12"> <h2>Contract Reducing Royalties</h2> </div>

                    <div className='box-content' ref={formValidation}>
                        <div className="ws-4">
                            <label className='ws-12 text-bold'>Region*</label>
                            <div className="label-entries ws-12 pt">
                                <select className='ws-11 full-height' value={editRate.groupDesc} required onChange={(e) => { seteditRate({ ...editRate, groupDesc: e.target.value }) }}>
                                    <option value="">Choose region</option>

                                    {systemRegions?.map((values: any, index: any) => {
                                        return (
                                            <option value={values.groupDesc} label={values.groupDesc} >{values.groupDesc}</option>
                                        )
                                    })}

                                </select>
                            </div>
                        </div>

                        <div className="ws-4">
                            <label className='ws-12 text-bold'>Analysis*</label>
                            <div className="label-entries ws-12 pt">

                                <select className='ws-11 full-height' value={editRate.analysisText} required onChange={(e) => { seteditRate({ ...editRate, analysisText: e.target.value }) }} name="percentage">
                                    <option value="">Choose Analysis code</option>

                                    {analysisCodes?.map((values: any, index: any) => {
                                        return (
                                            <option value={values.analysisText} label={values.analysisText} >{values.analysisText}</option>
                                        )
                                    })}

                                </select>

                            </div>
                        </div>

                        <div className="ws-4">
                            <label className='ws-12 text-bold'>Percentage*</label>
                            <input className=" ws-10 pt" type="number" value={editRate.percentage} name="percentage" onChange={(e) => handleFieldChange(e)} required />
                        </div>
                    </div>

                    <div className=' box-footer pull-right'>
                        <button className='icon-btn edit width90 height35' onClick={() => onReducingRoyaltySave()}>Save</button>
                        <button className='icon-btn delete width90 height35' onClick={() => { clearSForm() }}>Reset</button>

                    </div>
                </div>
            </div>

            <div className='ps ws-12'>
                <div className='box'>
                    <div className="box-header">
                        <h2><i className="fa fa-table"></i><span>{contractRoyaltiesListing.length} record(s) found</span></h2>
                    </div>

                    <div className="box-content">
                        {save && <div className="alert alert-success"> Rates/Basis has been saved successfully</div>}
                        {deleteAlert && <div className="alert alert-success"> Rates/Basis has been deleted successfully</div>}

                        <div className="form-horizontal row-fluid" >
                            <div className="form-format ws-8 pbl">
                                <label className="ws-12 pts mts pr text-bold" >Filter</label>

                                <div className="ws-9">
                                    <input type="text" className="form-control ws-12" value={searchFor} placeholder="Search" onChange={(e) => { setsearchFor(e.target.value); contractRoyaltyListingSearch(e.target.value) }} />
                                </div>
                            </div>
                        </div>

                        {(contractRoyaltiesListing.length == 0) && <div className="alert alert-info" >  No records to display </div>}

                        {(contractRoyaltiesListing.length > 0) && <div className="ws-12 allowVscroll">
                            <table className="table ws-12" >
                                <thead>
                                    <tr>
                                        <th className='text-bold'>Region</th>
                                        <th className='text-bold'>Analysis Code</th>
                                        <th className='text-bold'>Analysis Description</th>
                                        <th className='text-bold'>Percentage</th>
                                        <th className='text-bold'>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contractRoyaltiesListing.map((values: any) => {
                                        return (
                                            <tr>
                                                <td> {values.groupDesc}</td>
                                                <td> A{values.costId}</td>
                                                <td className="text-right ">{values.analysisText}</td>
                                                <td className="text-right ">{values.percentage}</td>
                                                <td >
                                                    <a className="icon-btn edit" onClick={() => seteditRate(values)}><i className="icon-edit1"></i></a>
                                                    <a className="icon-btn delete" onClick={() => onReducingRoyaltyDelete(values)}><i className="icon-trashcan"></i></a>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>}
                    </div>
                </div>
            </div>

            {
                (() => {

                    if (deleteJob && deleteJob.allowId) {
                        return <DeleteDialogueBox param={true} message={"delete region " + deleteJob.groupDesc + "(" + deleteJob.territoryCode + ")"} onChange={Confirmation} />
                    }
                })()
            }
        </>

    );
}
